import React, { Component } from 'react'
import '../styles/Home.css'
import NavBar from '../components/navigation';
import FadeIn from 'react-fade-in';
import Item from '../components/item';
import { benefits } from '../data/benefits.json'
import AOS from 'aos';
import 'aos/dist/aos.css';
import WaterWave from 'react-water-wave';
import image from '../images/background.png';
import Form from '../components/forms';
import Map from '../components/maps';
import Carousel from '../components/carousel';
import About from '../components/about';
import Footer from '../components/footer'
import What from '../components/what';
AOS.init();

class Home extends Component {
    state = {
        imageCarousel: 0
    }
    prev = () => {
        let num = this.state.imageCarousel;
        num--;
        if(num == -1){
            num = 3;
        }
        this.setState({imageCarousel: num})
    }
    next = () => {
        let num = this.state.imageCarousel;
        num++;
        if(num == 4){
            num = 0;
        }
        this.setState({imageCarousel: num})
    }
    render() {
        const items = benefits.map(el => {
            return <Item title={el.title} description={el.description} icon={el.icon} />
        })

        const logo = '/images/stack_logo.png'
        return ( 
                <div style={{ overflowY: 'hidden', padding: '0', margin: '0'}}>
                    <div>
                    <WaterWave
                        imageUrl={image}
                        style={{ backgroundSize: 'cover'}}>
                        {methods => (
                            <FadeIn>
                                <NavBar />
                                <div style={{ position: 'relative', height: '100vh', display: 'flex', flexDirection: 'column', marginTop: 'auto',overflowX: 'hidden' }}>
                                    <div style={styles.container}>
                                        <div data-aos="fade-in" data-aos-duration="1000" style={styles.heroContainer}>
                                            <img  style={{ height: '200px' }} src={logo} alt="Company logo" />
                                            <h4 style={{ paddingTop: '.25em', fontSize: '1em', color: 'lightgrey' }}>Foam Pro-portioner Testing for <span style={styles.label}>HEF</span>, <span style={styles.label}>AR</span> and <span style={styles.label}>AFFF</span> Systems</h4>
                                            <p style={{ fontSize: '1.4rem', marginTop: '.75em', color: 'lightgrey' }}>
                                                An Eco Friendly Company Doing<br />Eco Friendly Testing!
                                            </p>
                                        </div>
                                        <a data-aos="fade-up" data-aos-duration="1000" className="explore" href="#about">EXPLORE</a>
                                    </div>
                                    
                                    <canvas></canvas>
                                </div>
                            </FadeIn>
                        
                        )}
                    </WaterWave>
                    </div>
                    <div>
                        <What />
                    </div>
                    <div>
                        <About />
                    </div>
                    <div>
                        <Carousel />
                    </div>
                    
                    <div className="gradient-one">
                        <div style={{backgroundColor: 'white', paddingTop: '2rem'}} id="about" className="slide section-container">
                            <h2 data-aos="fade-up" data-aos-duration="1000" style={{ fontWeight: '400', fontSize: '2em', textTransform: 'uppercase' }}>Benefits<br />Using Our Process</h2>
                            <div className="c-box">
                                <div className="item-desc-seperator" />
                                <img src="./images/water-drop.svg" alt="" />
                                <div className="item-desc-seperator" />
                            </div>
                            <div>
                                <div data-aos="fade-up" data-aos-duration="1000" className="about-grid">
                                    <Item title={benefits[0].title} description={benefits[0].description} icon={benefits[0].icon} />
                                    <Item title={benefits[1].title} description={benefits[1].description} icon={benefits[1].icon} />
                                    <Item title={benefits[2].title} description={benefits[2].description} icon={benefits[2].icon} />
                                </div>
                                <div data-aos="fade-up" data-aos-duration="1000" className="about-grid">
                                    <Item title={benefits[3].title} description={benefits[3].description} icon={benefits[3].icon} />
                                    <Item title={benefits[4].title} description={benefits[4].description} icon={benefits[4].icon} />
                                    <Item title={benefits[5].title} description={benefits[5].description} icon={benefits[5].icon} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <Map />
                    <div id="contact-nav" className="contact-container">
                        <h2>Contact Our Sales<br />Team</h2>
                        <div className="contact-seperator" />
                        <div className="contact-flex-container">
                            <div className="contact-item">
                                <img className="contact-image" src="/images/drop.svg" alt="Company logo" />
                            </div>
                            <div className="contact-item">
                                <h3>We'd love to<br />hear from you</h3>
                                <div className="hours-container">
                                    <div className="hours">
                                        <p>Monday - Friday</p>
                                        <p>Saturday</p>
                                    </div>
                                    <div className="hours" style={{paddingLeft: '1em'}}>
                                        <p>8am to 5pm <span className="contact-span">EST</span></p>
                                        <p>8am to 2pm <span className="contact-span">EST</span></p>
                                    </div>
                                </div>
                                <div style={{paddingBottom: '.5em'}}>
                                    <p>ps@fs131.com</p>
                                    <p style={{color: 'darkgrey  '}}>1-614-586-1326</p>
                                </div>
                                <div>
                                    <p style={{color: 'darkgrey' }}>2251 Performance Parkway<br />Columbus, OH 43207<br />United States of America</p>
                                </div>
                            </div>
                            <Form />
                        </div>
                    </div>
                    <Footer />
                </div>
                
            );
    }
}
export default Home;

const styles = {
    container: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        zIndex: '10',
        height: '100vh',
        width: '50%',
        margin: '0 auto'
    },
    header: {
        display: 'flex',
        height: '100vh',
        alignItems: 'center',
    },
    secondNav: {
        padding: '1em 5em',
        display: 'flex',
        flexDirection: 'row'
    },
    secondNavIcon: {
        height: '50px'
    },
    heroContainer: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        padding: 'auto',
        color: 'white'
    },
    label: {
        color: '#00B9AE'
    },

}
